// iCoins Collection \u00b7 Registro Gold 24K (secci\u00f3n del tema de Shopify)
// Sin servidor propio:
//  1. Supabase comprueba que la moneda (jugador + serie) est\u00e9 libre.
//  2. Cloudflare Turnstile comprueba que no es un robot.
//  3. La foto se sube a Cloudinary.
//  4. La funci\u00f3n "registrar" de Supabase verifica el captcha y registra la moneda
//     (cada moneda solo se puede registrar una vez).
//  5. El registro va a Klaviyo con su API p\u00fablica.
// "Mis Gold 24K": si el cliente inici\u00f3 sesi\u00f3n, Shopify firma su email y la funci\u00f3n
// "mis-monedas" de Supabase devuelve las monedas registradas con ese email.
// La configuraci\u00f3n viene de los ajustes de la secci\u00f3n (atributos data-* de .irm).
(function () {
  var root = document.querySelector('[data-irm]');
  if (!root) return;

  var d = root.dataset;
  var CONFIG = {
    club: d.club,
    maxSerie: parseInt(d.maxSerie, 10) || 1902,
    supportEmail: d.supportEmail,
    supabase: { url: (d.supabaseUrl || '').replace(/\/+$/, ''), publishableKey: d.supabaseKey },
    cloudinary: { cloudName: d.cloudinaryCloud, uploadPreset: d.cloudinaryPreset },
    turnstile: { siteKey: d.turnstileKey },
    klaviyo: {
      publicKey: d.klaviyoKey,
      listId: d.klaviyoList,
      prefix: d.klaviyoPrefix || 'gold24k_',
      revision: '2025-01-15',
      metric: 'Registr\u00f3 Gold 24K',
      source: 'Registro Gold 24K ' + d.club
    }
  };
  var MAX_PHOTO_SIDE = 1600;
  var customer = d.sig ? { email: d.customerEmail, ts: d.ts, sig: d.sig } : null;

  var main = root.querySelector('[data-irm-main]');
  var success = root.querySelector('[data-irm-success]');
  var form = root.querySelector('[data-irm-form]');
  var el = form.elements;
  var submit = root.querySelector('[data-irm-submit]');
  var submitLabel = submit.textContent;
  var formError = root.querySelector('[data-irm-form-error]');
  var serieField = form.querySelector('[data-field="serie"]');
  var serieError = serieField.querySelector('.irm-field__error');
  var serieErrorDefault = serieError.textContent;
  var serieStatus = root.querySelector('[data-irm-serie-status]');
  var upload = root.querySelector('[data-irm-upload]');
  var preview = root.querySelector('[data-irm-upload-preview]');
  var plus = root.querySelector('[data-irm-upload-plus]');
  var uploadTitle = root.querySelector('[data-irm-upload-title]');
  var uploadTitleDefault = uploadTitle.textContent;

  // ---------- Formulario ----------
  el.serie.addEventListener('input', function () {
    el.serie.value = el.serie.value.replace(/\D/g, '');
  });

  // Al elegir jugador y escribir la serie se avisa si la moneda est\u00e1 libre
  var checkTimer = null;
  var checkSeq = 0;
  function scheduleCheck() {
    clearTimeout(checkTimer);
    setStatus('');
    var dorsal = parseInt(el.jugador.value, 10);
    var serie = parseInt(el.serie.value, 10);
    if (!dorsal || !(serie >= 1 && serie <= CONFIG.maxSerie)) return;
    checkTimer = setTimeout(function () {
      var seq = ++checkSeq;
      setStatus('Comprobando\u2026', 'is-checking');
      rpc('moneda_disponible', { p_club: CONFIG.club, p_dorsal: dorsal, p_serie: serie })
        .then(function (estado) {
          if (seq !== checkSeq) return;
          if (estado === 'disponible') setStatus('\u2713 Disponible', 'is-ok');
          else if (estado === 'registrada') { setStatus(''); showTaken(); }
          else setStatus('');
        })
        .catch(function () { if (seq === checkSeq) setStatus(''); });
    }, 400);
  }
  function setStatus(text, cls) {
    serieStatus.textContent = text;
    serieStatus.className = 'irm-field__status' + (cls ? ' ' + cls : '');
  }
  function showTaken() {
    serieError.textContent = 'Esta moneda ya est\u00e1 registrada.' + (CONFIG.supportEmail
      ? ' Si es tuya, escr\u00edbenos a ' + CONFIG.supportEmail + '.'
      : ' Si es tuya, cont\u00e1ctanos.');
    serieField.classList.add('is-invalid');
  }
  el.jugador.addEventListener('change', scheduleCheck);
  el.serie.addEventListener('input', scheduleCheck);

  // Vista previa de la foto (los HEIC no se pueden previsualizar en todos los navegadores)
  el.foto.addEventListener('change', function () {
    var file = el.foto.files && el.foto.files[0];
    upload.classList.toggle('is-filled', !!file);
    preview.hidden = true;
    plus.hidden = false;
    uploadTitle.textContent = file ? file.name : uploadTitleDefault;
    if (file && /^image\/(jpeg|png)$/.test(file.type)) {
      preview.src = URL.createObjectURL(file);
      preview.hidden = false;
      plus.hidden = true;
    }
  });

  // Al corregir un campo se le quita el error
  form.addEventListener('input', clearError);
  form.addEventListener('change', clearError);
  function clearError(event) {
    var field = event.target.closest('[data-field]');
    if (field) field.classList.remove('is-invalid');
    if (event.target === el.jugador || event.target === el.serie) serieError.textContent = serieErrorDefault;
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (submit.disabled) return;

    // Antibots: si el campo invisible viene completo, se ignora el env\u00edo
    if (el.web.value) return;

    var serie = parseInt(el.serie.value, 10);
    var checks = {
      jugador: el.jugador.value !== '',
      serie: serie >= 1 && serie <= CONFIG.maxSerie,
      foto: el.foto.files && el.foto.files.length > 0,
      nombre: el.nombre.value.trim().length > 1,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.email.value.trim()),
      bases: el.bases.checked
    };

    var firstInvalid = null;
    Object.keys(checks).forEach(function (name) {
      var field = form.querySelector('[data-field="' + name + '"]');
      field.classList.toggle('is-invalid', !checks[name]);
      if (!checks[name] && !firstInvalid) firstInvalid = field;
    });
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var registro = {
      jugador: el.jugador.value,
      dorsal: el.jugador.value.split(' ')[0],
      serie: String(serie).padStart(4, '0'),
      nombre: el.nombre.value.trim(),
      email: el.email.value.trim().toLowerCase(),
      novedades: el.novedades.checked
    };

    formError.hidden = true;
    submit.disabled = true;
    submit.textContent = 'Comprobando moneda\u2026';

    // Primero se comprueba que est\u00e9 libre, para no subir la foto en vano
    rpc('moneda_disponible', { p_club: CONFIG.club, p_dorsal: Number(registro.dorsal), p_serie: serie })
      .then(function (estado) {
        if (estado === 'registrada') throw failure('registrada', 'moneda ya registrada');
        if (estado !== 'disponible') throw failure('invalida', estado);
        return getCaptchaToken();
      })
      .then(function (token) {
        registro.token = token;
        submit.textContent = 'Subiendo foto\u2026';
        return prepareImage(el.foto.files[0]).then(function (file) { return uploadPhoto(file, registro); });
      })
      .then(function (fotoUrl) {
        registro.foto = fotoUrl;
        submit.textContent = 'Registrando\u2026';
        // La base de datos tiene la \u00faltima palabra: si alguien la registr\u00f3 un segundo antes, se rechaza
        return registerCoin(registro, serie);
      })
      .then(function (estado) {
        if (estado === 'registrada') throw failure('registrada', 'moneda ya registrada');
        if (estado !== 'ok' && estado !== 'ya_tuya') throw failure('invalida', estado);
        // Si Klaviyo falla, la moneda ya est\u00e1 registrada: se muestra la confirmaci\u00f3n igual
        return sendToKlaviyo(registro).catch(function (err) { console.error('[registro] klaviyo', err); });
      })
      .then(function () {
        submit.disabled = false;
        submit.textContent = submitLabel;
        var moneda = { dorsal: Number(registro.dorsal), serie: registro.serie };
        saveLocal(moneda);
        if (!customer || registro.email === customer.email) markOwned([moneda]);
        showSuccess(registro);
      })
      .catch(function (error) {
        console.error('[registro]', error);
        submit.disabled = false;
        submit.textContent = submitLabel;
        if (error.step === 'registrada') {
          showTaken();
          serieField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        formError.textContent = {
          foto: 'No pudimos subir la foto. Revisa tu conexi\u00f3n o prueba con otra imagen.',
          captcha: 'No pudimos comprobar que no eres un robot. Recarga la p\u00e1gina e int\u00e9ntalo de nuevo.',
          invalida: 'Revisa los datos de tu moneda: el jugador o el n\u00famero de serie no son v\u00e1lidos.'
        }[error.step] || 'No pudimos completar el registro. Int\u00e9ntalo de nuevo en unos minutos.';
        formError.hidden = false;
      });
  });

  // ---------- Confirmaci\u00f3n ----------
  function showSuccess(r) {
    var render = renderFor(r.dorsal);
    var coin = root.querySelector('[data-irm-out-coin]');
    var img = root.querySelector('[data-irm-out-img]');
    root.querySelector('[data-irm-out-dorsal]').textContent = r.dorsal;
    root.querySelector('[data-irm-out-jugador]').textContent = r.jugador;
    root.querySelector('[data-irm-out-serie]').textContent = r.serie;
    // Render oficial de la moneda si est\u00e1 cargado; si no, el disco con el dorsal
    coin.hidden = !!render;
    img.hidden = !render;
    if (render) img.src = render;
    main.hidden = true;
    success.hidden = false;
    // As\u00ed el bot\u00f3n "atr\u00e1s" del navegador vuelve a la p\u00e1gina (con la colecci\u00f3n) y no sale de ella
    try { history.pushState({ irm: 'registrada' }, '', '#irm-registrada'); } catch (e) {}
    window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 20, behavior: 'smooth' });
  }

  function showMain(target) {
    if (success.hidden) return;
    success.hidden = true;
    main.hidden = false;
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function clearSuccessUrl() {
    if (location.hash === '#irm-registrada') {
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    }
  }

  clearSuccessUrl(); // si se recarga la p\u00e1gina con #irm-registrada

  window.addEventListener('popstate', function () {
    if (success.hidden) return;
    showMain();
    // El navegador restaura su propia posici\u00f3n al ir atr\u00e1s: se baja a la colecci\u00f3n justo despu\u00e9s
    setTimeout(function () {
      document.getElementById('irm-coleccion').scrollIntoView({ block: 'start' });
    }, 60);
  });

  root.querySelector('[data-irm-again]').addEventListener('click', function () {
    // Se conservan nombre y email para registrar otra moneda m\u00e1s r\u00e1pido
    el.jugador.value = '';
    el.serie.value = '';
    el.foto.value = '';
    el.foto.dispatchEvent(new Event('change'));
    setStatus('');
    clearSuccessUrl();
    showMain(form);
  });

  root.querySelector('[data-irm-go-coleccion]').addEventListener('click', function (event) {
    event.preventDefault();
    clearSuccessUrl();
    showMain(document.getElementById('irm-coleccion'));
  });

  // Compartir: men\u00fa nativo del m\u00f3vil; en escritorio copia el texto con el enlace
  root.querySelector('[data-irm-share]').addEventListener('click', function () {
    var label = root.querySelector('[data-irm-share-label]');
    var text = '\u00a1Ya tengo mi moneda Gold 24K de la iCoins Collection del ' + CONFIG.club + '! #SpreadTheJoy';
    var url = location.origin + location.pathname;
    if (navigator.share) {
      navigator.share({ text: text, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text + ' ' + url).then(function () {
        label.textContent = '\u00a1Texto copiado!';
        setTimeout(function () { label.textContent = 'Comp\u00e1rtelo con #SpreadTheJoy'; }, 2000);
      });
    }
  });

  // ---------- Mis Gold 24K ----------
  // Con sesi\u00f3n: las monedas registradas con el email de la cuenta (funci\u00f3n "mis-monedas").
  // Sin sesi\u00f3n: las registradas desde este navegador (se guardan en el dispositivo).
  var grid = root.querySelector('[data-irm-grid]');
  var note = root.querySelector('[data-irm-coleccion-note]');
  var owned = {};
  var LOCAL_KEY = 'irm-monedas:' + CONFIG.club;

  function renderFor(dorsal) {
    var slot = grid && grid.querySelector('[data-dorsal="' + dorsal + '"]');
    return slot ? slot.getAttribute('data-render') : null;
  }

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]'); } catch (e) { return []; }
  }

  function saveLocal(m) {
    try {
      var list = readLocal().filter(function (x) { return !(x.dorsal === m.dorsal && x.serie === m.serie); });
      list.push(m);
      localStorage.setItem(LOCAL_KEY, JSON.stringify(list));
    } catch (e) { /* sin almacenamiento: solo se ver\u00e1 con la cuenta */ }
  }

  function loadCollection() {
    if (!grid) return;
    if (!customer && d.loggedIn !== undefined) {
      // Hay sesi\u00f3n pero la secci\u00f3n no tiene la "Clave secreta de firma": no se puede leer la cuenta
      console.error('[registro] falta la clave secreta de firma en los ajustes de la secci\u00f3n');
    }
    var local = readLocal();
    // Las monedas registradas desde este dispositivo se muestran siempre (con o sin sesi\u00f3n)
    if (local.length) markOwned(local);
    if (!customer) {
      if (local.length) {
        var login = note.querySelector('a');
        note.textContent = 'Estas son las monedas que registraste desde este dispositivo. ';
        if (login) {
          login.textContent = 'Entra con tu cuenta';
          note.appendChild(login);
          note.appendChild(document.createTextNode(' para verlas desde cualquier lugar.'));
        }
      }
      return;
    }
    fetch(CONFIG.supabase.url + '/functions/v1/mis-monedas', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'apikey': CONFIG.supabase.publishableKey },
      body: JSON.stringify({ email: customer.email, ts: customer.ts, sig: customer.sig, club: CONFIG.club })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.estado === 'ok') {
          markOwned(json.monedas || []);
          if (!(json.monedas || []).length) {
            note.innerHTML += ' Todav\u00eda no tienes monedas registradas con este email.';
          }
          return;
        }
        console.error('[registro] mis-monedas', json.estado);
        note.textContent = json.estado === 'caducada'
          ? 'Recarga la p\u00e1gina para ver tu colecci\u00f3n.'
          : 'No pudimos cargar tu colecci\u00f3n (' + json.estado + '). Escr\u00edbenos a ' + (CONFIG.supportEmail || 'soporte') + '.';
      })
      .catch(function (err) {
        console.error('[registro] mis-monedas', err);
        note.textContent = 'No pudimos cargar tu colecci\u00f3n. Recarga la p\u00e1gina para intentarlo de nuevo.';
      });
  }

  function markOwned(monedas) {
    monedas.forEach(function (m) {
      var key = String(m.dorsal);
      owned[key] = owned[key] || [];
      if (owned[key].indexOf(m.serie) === -1) owned[key].push(m.serie);
    });
    var slots = grid.querySelectorAll('[data-dorsal]');
    var count = 0;
    Array.prototype.forEach.call(slots, function (slot) {
      var series = owned[slot.getAttribute('data-dorsal')];
      if (!series) return;
      count++;
      slot.classList.add('is-owned');
      slot.querySelector('[data-irm-slot-status]').textContent = 'Serie ' + series.join(' \u00b7 ');
      var render = slot.getAttribute('data-render');
      if (render) {
        var img = slot.querySelector('.irm-slot__img');
        img.src = render;
        img.alt = 'Moneda Gold 24K de ' + (slot.getAttribute('data-name') || '');
        img.hidden = false;
        var placeholder = slot.querySelector('.irm-slot__coin, .irm-slot__base');
        if (placeholder) placeholder.hidden = true;
      }
    });
    root.querySelector('[data-irm-count]').textContent = count;
    root.querySelector('[data-irm-bar]').style.width = (slots.length ? Math.round(count / slots.length * 100) : 0) + '%';
  }

  loadCollection();

  // ---------- Foto ----------
  // Achica la foto en el navegador (m\u00e1x. 1600 px, JPG). Si el navegador no puede
  // leerla (p. ej. HEIC fuera de Safari) se sube tal cual y Cloudinary la convierte.
  function prepareImage(file) {
    if (!window.createImageBitmap) return Promise.resolve(file);
    return createImageBitmap(file).then(function (bitmap) {
      var scale = Math.min(1, MAX_PHOTO_SIDE / Math.max(bitmap.width, bitmap.height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      return new Promise(function (resolve) {
        canvas.toBlob(function (blob) {
          resolve(blob ? new File([blob], 'moneda.jpg', { type: 'image/jpeg' }) : file);
        }, 'image/jpeg', 0.85);
      });
    }).catch(function () { return file; });
  }

  function uploadPhoto(file, r) {
    var data = new FormData();
    data.append('file', file);
    data.append('upload_preset', CONFIG.cloudinary.uploadPreset);
    // Etiquetas y datos para encontrar la foto en Cloudinary por jugador o serie
    data.append('tags', 'dorsal-' + r.dorsal);
    data.append('context', 'club=' + CONFIG.club + '|jugador=' + r.jugador + '|serie=' + r.serie);
    return fetch('https://api.cloudinary.com/v1_1/' + CONFIG.cloudinary.cloudName + '/image/upload', {
      method: 'POST',
      body: data
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok || !json.secure_url) throw failure('foto', json.error ? json.error.message : res.status);
          // Siempre en JPG, para que se vea en Klaviyo y en cualquier navegador
          return json.secure_url.replace(/\.[a-z0-9]+$/i, '.jpg');
        });
      }, function (err) { throw failure('foto', err.message); });
  }

  // ---------- Supabase ----------
  // Comprobaci\u00f3n p\u00fablica (las tablas no se pueden leer desde la p\u00e1gina)
  function rpc(name, args) {
    return fetch(CONFIG.supabase.url + '/rest/v1/rpc/' + name, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'apikey': CONFIG.supabase.publishableKey },
      body: JSON.stringify(args)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw failure('supabase', name + ' ' + res.status + ' ' + JSON.stringify(json));
        return json;
      });
    }, function (err) { throw failure('supabase', err.message); });
  }

  // Registro final a trav\u00e9s de la funci\u00f3n "registrar", que verifica el captcha
  function registerCoin(r, serie) {
    return fetch(CONFIG.supabase.url + '/functions/v1/registrar', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'apikey': CONFIG.supabase.publishableKey },
      body: JSON.stringify({
        token: r.token,
        club: CONFIG.club,
        dorsal: Number(r.dorsal),
        serie: serie,
        nombre: r.nombre,
        email: r.email,
        foto_url: r.foto,
        novedades: r.novedades
      })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (json.estado === 'captcha') throw failure('captcha', 'rechazado por el servidor');
        if (!json.estado || json.estado === 'error') throw failure('supabase', 'registrar ' + res.status);
        return json.estado;
      });
    }, function (err) { throw failure('supabase', err.message); });
  }

  // ---------- Klaviyo ----------
  // Un evento por registro (crea o actualiza el perfil con sus datos) y, si acept\u00f3
  // las novedades, la suscripci\u00f3n a la lista (Klaviyo env\u00eda el email de confirmaci\u00f3n).
  function sendToKlaviyo(r) {
    var k = CONFIG.klaviyo;
    var partes = r.nombre.split(/\s+/);
    var props = {};
    props[k.prefix + 'jugador'] = r.jugador;
    props[k.prefix + 'dorsal'] = Number(r.dorsal);
    props[k.prefix + 'serie'] = r.serie;
    props[k.prefix + 'foto'] = r.foto;
    props[k.prefix + 'fecha'] = new Date().toISOString();

    var requests = [klaviyo('events', {
      data: {
        type: 'event',
        attributes: {
          properties: {
            club: CONFIG.club,
            jugador: r.jugador,
            dorsal: Number(r.dorsal),
            serie: r.serie,
            foto: r.foto,
            novedades: r.novedades
          },
          unique_id: [CONFIG.club, r.dorsal, r.serie, r.email].join('|'),
          metric: { data: { type: 'metric', attributes: { name: k.metric } } },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: r.email,
                first_name: partes[0],
                last_name: partes.slice(1).join(' ') || undefined,
                properties: props
              }
            }
          }
        }
      }
    })];

    if (r.novedades && k.listId) {
      requests.push(klaviyo('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: k.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: r.email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: k.listId } } }
        }
      }));
    }

    return Promise.all(requests);
  }

  function klaviyo(endpoint, body) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + CONFIG.klaviyo.publicKey, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': CONFIG.klaviyo.revision
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (text) { throw failure('klaviyo', endpoint + ' ' + res.status + ' ' + text); });
      }
    }, function (err) { throw failure('klaviyo', err.message); });
  }

  // ---------- Cloudflare Turnstile ----------
  // El widget se pide al enviar el formulario (modo "execute") y solo se ve si Cloudflare duda.
  var captcha = { id: null, pending: null };
  var captchaBox = root.querySelector('[data-irm-captcha]');

  window.irmTurnstileLoad = function () {
    if (captcha.id !== null || !window.turnstile || !window.turnstile.render) return;
    captcha.id = window.turnstile.render(captchaBox, {
      sitekey: CONFIG.turnstile.siteKey,
      execution: 'execute',
      appearance: 'interaction-only',
      language: 'es',
      callback: function (token) { settleCaptcha(null, token); },
      'error-callback': function () { settleCaptcha(failure('captcha', 'error del widget')); },
      'expired-callback': function () { settleCaptcha(failure('captcha', 'caducado')); }
    });
  };
  window.irmTurnstileLoad();

  function getCaptchaToken() {
    return new Promise(function (resolve, reject) {
      if (!window.turnstile || captcha.id === null) return reject(failure('captcha', 'no carg\u00f3'));
      captcha.pending = { resolve: resolve, reject: reject };
      window.turnstile.reset(captcha.id);
      window.turnstile.execute(captcha.id);
    });
  }

  function settleCaptcha(error, token) {
    var p = captcha.pending;
    captcha.pending = null;
    if (!p) return;
    if (error) p.reject(error); else p.resolve(token);
  }

  function failure(step, detail) {
    var error = new Error(step + ': ' + detail);
    error.step = step;
    return error;
  }
})();
